module.exports = __webpack_public_path__ + "img/sound.a55a685b.gif";